<template>
  <div>
    <!-- 제목 -->
    <v-sheet outlined class="d-flex align-center ma-2 px-4" height="60">
      <font class="font-weight-bold text-h6 grey--text text--darken-2">드레스 예약 스케줄</font>
    </v-sheet>

    <!-- 본문 -->
    <v-sheet class="ma-2 pa-4" outlined>
      <!-- 날짜 선택 -->
      <DateSelector :color="$vuetify.theme.currentTheme.primary" :width="330" class="mt-1 mb-4" @dateUpdated="dateUpdated_handler" />

      <!-- 시간테이블 -->
      <table class="timeTable">
        <tr v-for="item in timeTable" :key="item.time">
          <!-- 시간 -->
          <td style="height: 80px; width: 100px; background: rgba(195, 126, 120, 0.15); text-align: center">
            <p class="mb-0">
              {{ item.time }}
            </p>
            <p class="mb-0 text-caption font-weight-medium primary--text text--lighten-1">
              {{ reservation_list.filter((obj) => obj.time === item.time).reduce((sum, obj) => sum + (obj.cloth + obj.uncloth || 0), 0) }} / 10
            </p>
          </td>

          <!-- 예약이 없는 경우 -->
          <td
            v-if="!reservation_list.map((e) => e.time).includes(item.time)"
            style="height: 80px"
            :class="item.is_rest != '' ? 'rest' : item.is_rest != '' ? 'reservation' : ''"
            @click="openMemo(item)"
          >
            <span v-if="!item.is_rest && item.memo">{{ item.memo }}</span>
            <span v-if="item.is_rest">휴식</span>
          </td>

          <!-- 예약이 있는 경우 -->
          <td v-else class="pa-1 pr-0" style="background: #f1f1f1">
            <div class="d-flex justify-center">
              <v-sheet
                v-for="reservation in reservation_list.filter((obj) => obj.time === item.time)"
                :key="reservation.id"
                height="80"
                width="120"
                class="rounded-10 primary lighten-1 white--text text-center mr-1"
                :style="isOnlineReservation(reservation) ? 'background-color: #a26867 !important' : 'background-color: #54916c !important'"
                @click="detailCastle(reservation)"
              >
                <p class="text-body-2 mt-14px mb-0 text-truncate px-2" :style="reservation.name == null ? 'color:red;' : ''" style="line-height: 16px">
                  {{ reservation.name ? reservation.name : reservation.user_id }}
                </p>
                <p class="text-caption font-weight-medium">
                  드: {{ reservation.cloth }} / 미: {{ reservation.uncloth }} <br />
                  디: {{ reservation.dessertAmount || 0 }} / 연장: {{ reservation.extra_time_persons || 0 }}
                </p>
              </v-sheet>
            </div>
          </td>
        </tr>
      </table>
    </v-sheet>

    <!-- 메모하기 (dialog) -->
    <v-dialog v-model="dialog.memo" width="440" content-class="rounded-xl">
      <v-sheet class="px-16 pt-8 pb-6">
        <!-- 제목 -->
        <p class="mb-6 font-weight-bold text-center" style="font-size: 24px">메모하기</p>

        <v-text-field class="rounded-15" outlined :disabled="selectedItem.is_rest" v-model="selectedItem.memo" counter="10"></v-text-field>
        <v-btn
          depressed
          class="rounded-15 d-block mx-auto px-16"
          :class="selectedItem.is_rest ? 'green white--text' : 'grey lighten-2'"
          @click="
            selectedItem.is_rest = !selectedItem.is_rest
            dialog.memo = false
          "
        >
          휴식
        </v-btn>

        <!-- 버튼 -->
        <div class="d-flex justify-center mt-4">
          <!-- 취소 -->
          <v-btn
            width="100"
            depressed
            color="grey lighten-3"
            class="font-weight-bold rounded-10 mr-3"
            @click="
              selectedItem.is_rest = false
              selectedItem.memo = ''
              dialog.memo = false
            "
          >
            비우기
          </v-btn>

          <!-- 제출 -->
          <v-btn width="100" dark depressed class="font-weight-bold rounded-10" @click="dialog.memo = false"> 입력 </v-btn>
        </div>
      </v-sheet>
    </v-dialog>

    <!-- 예약 상세보기 (dialog) -->
    <v-dialog v-model="dialog.detail" width="460" content-class="rounded-xl">
      <v-sheet class="pt-8 pb-6">
        <!-- 제목 -->
        <p class="mb-6 font-weight-bold text-center" style="font-size: 24px">예약 상세보기</p>

        <table class="table_detail mx-auto">
          <tr>
            <td>예약자명</td>
            <td>{{ selected_reservation.name }}</td>
          </tr>
          <tr>
            <td>전화번호</td>
            <td>{{ selected_reservation.phone }}</td>
          </tr>
          <tr>
            <td>이메일</td>
            <td>{{ selected_reservation.email }}</td>
          </tr>
          <tr style="height: 16px"></tr>
          <tr>
            <td>인원수</td>
            <td>대여 {{ selected_reservation.cloth }}명, 미대여 {{ selected_reservation.uncloth }}명</td>
          </tr>
          <tr>
            <td>시간연장</td>
            <td>{{ selected_reservation.extra_time_persons || 0 }}명</td>
          </tr>
          <tr>
            <td>디저트</td>
            <td>{{ selected_reservation.dessertProductName }} {{ selected_reservation.dessertAmount || 0 }}개</td>
          </tr>
          <tr>
            <td>결제일</td>
            <td>{{ new Date(selected_reservation.created).toLocaleDateString() }}</td>
          </tr>
          <tr>
            <td>이용일</td>
            <td>{{ selected_reservation.year }}.{{ selected_reservation.month }}.{{ selected_reservation.day }} / {{ selected_reservation.time }}</td>
          </tr>
          <tr style="height: 16px"></tr>
          <tr>
            <td>상태</td>
            <td>{{ selected_reservation.status }}</td>
          </tr>
          <tr>
            <td>결제수단</td>
            <td>신용카드</td>
          </tr>
          <tr>
            <td>결제금액</td>
            <td>{{ $toComma(selected_reservation.pay_amount || 0) }}원</td>
          </tr>
          <tr v-if="selected_reservation.toss_id > 0">
            <td>취소가능금액</td>
            <td>{{ $toComma(selected_reservation.balance_amount || 0) }}원</td>
          </tr>
          <tr v-else>
            <td class="text-center mx-auto" colspan="2">현장 결제 처리</td>
          </tr>
          <tr>
            <td>프로모션</td>
            <td>{{ selected_reservation.promotionCode || "-" }}</td>
          </tr>

          <!-- <tr style="height:16px;"></tr>
                    <tr>
                        <td>이용이력</td>
                        <td>없음</td>
                    </tr> -->
        </table>

        <!-- 버튼 -->
        <div class="d-flex justify-center mt-8">
          <!-- 취소 -->
          <v-btn width="100" depressed color="grey lighten-3" class="font-weight-bold rounded-10 mr-3" @click="dialog.detail = false"> 닫기 </v-btn>

          <!-- 제출 -->
          <v-btn width="100" dark depressed class="font-weight-bold rounded-10" @click="reservation_cancel()" :loading="reservation_canceling" :disabled="reservation_cancel_disabled">
            예약취소
          </v-btn>
        </div>
      </v-sheet>
    </v-dialog>
  </div>
</template>
<script>
import DateSelector from "@/components/DateSelector"

export default {
  components: {
    DateSelector,
  },

  data: () => ({
    date: null,

    timeTable: [
      { time: "12:00", is_reservation: false, memo: "", is_rest: false },
      { time: "13:00", is_reservation: false, memo: "", is_rest: false },
      { time: "14:00", is_reservation: false, memo: "", is_rest: false },
      { time: "15:00", is_reservation: false, memo: "", is_rest: false },
      { time: "16:00", is_reservation: false, memo: "", is_rest: false },
      { time: "17:00", is_reservation: false, memo: "", is_rest: false },
      { time: "18:00", is_reservation: false, memo: "", is_rest: false },
      { time: "19:00", is_reservation: false, memo: "", is_rest: false },
    ],

    selectedItem: {},
    list: [],

    reservation_list: [
      {
        time: "",
        name: "",
      },
    ],

    selected_reservation: {},

    dialog: {
      memo: false,
      detail: false,
    },

    reservation_canceling: false, // 예약 취소 진행중
  }),

  watch: {
    date() {
      // 라피아캐슬 예약 불러오기
      this.loadCastleTime()
    },
  },

  computed: {
    reservation_cancel_disabled() {
      console.log(this.selected_reservation)
      return this.selected_reservation.toss_id <= 0
    },
  },

  methods: {
    // DateSelector에서 date 가져오기
    dateUpdated_handler(date) {
      this.date = date
    },

    // 라피아캐슬 예약 불러오기
    loadCastleTime() {
      this.$http
        .post("/api/reservation/select/specific/day/category/all", {
          params: {
            category: "라피아캐슬",
            year: this.date.year(),
            month: this.date.month() + 1,
            day: this.date.date(),
          },
        })
        .then((res) => {
          console.log(this.date.format("YYYY년 MM월 DD일"))
          console.log("예약 목록:", res.data)
          this.reservation_list = res.data
        })
    },

    openMemo(item) {
      this.selectedItem = item
      this.dialog.memo = true
    },

    // 주문 상세
    detailCastle(reservation) {
      this.selected_reservation = reservation
      this.dialog.detail = true
    },

    isOnlineReservation(reservation) {
      return reservation.toss_id > 0
    },

    // 예약 취소하기
    reservation_cancel: _.debounce(async function () {
      if (!this.selected_reservation) {
        alert("선택한 항목이 없습니다.")
        return
      }
      if (!this.selected_reservation.balance_amount) {
        alert("취소 가능한 금액이 없습니다.")
        return
      }

      let confirmMessage = `해당 ${this.selected_reservation.name} 의 ${this.selected_reservation.month}/${this.selected_reservation.day} ${this.selected_reservation.time} 예약을 정말로 취소하시겠습니까? 취소금액은 ${this.selected_reservation.balance_amount} 입니다.`

      if (confirm(confirmMessage)) {
        try {
          this.reservation_canceling = true

          const response = await this.$http.post("/api/payments/toss/order/cancel", {
            orderListId: this.selected_reservation.order_id,
            paymentKey: this.selected_reservation.paymentKey,
            cancelAmount: this.selected_reservation.balance_amount,
            cancelReason: "관리자 취소",
            isAdmin: true,
            isAll: true,
            adminId: this.$store.state.lafia_admin.user_id,
          })
          if (response.data.orderId) {
            alert("예약이 정상적으로 취소되었습니다.")
            this.loadCastleTime()
            this.dialog.detail = false
          }
        } catch (e) {
          console.log(e)
        } finally {
          this.reservation_canceling = false
        }
      }
    }, 500),
  },
}
</script>
<style scoped>
.timeTable {
  /* width: 100%;
    max-width: 1030px; */
  width: 100%;
  min-width: 1030px;
  max-width: 1280px;
  border: 1px solid #ccc;
  border-collapse: collapse;
  text-align: center;
  font-weight: 500;
}

.timeTable tr td {
  padding: 4px 8px;
  height: 70px;
  cursor: pointer;
  border: 1px solid #ccc;
}

.reservation {
  cursor: pointer;
  background: #ffb19c;
  color: white;
  font-weight: 300;
}

.rest {
  cursor: pointer;
  background: #ccc;
  color: white;
  font-weight: 300;
}

/* 상세보기 */
.table_detail {
  background: white;
}

.table_detail tr td {
  padding: 4px;
}

.table_detail tr td:first-child {
  width: 120px;
  padding: 4px;
}
</style>
